import styled from 'styled-components';

export const ModalTitle = styled.h4``;

export const ModalContainer = styled.div`
  font-size: 18px;
  font-weight: 500;
`;
